import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SITE_NAME } from '../../types';

@Component({
  selector: 'app-site-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatToolbarModule,
  ],
  templateUrl: './site-toolbar.component.html',
  styleUrl: './site-toolbar.component.scss',
})
export class SiteToolbarComponent {
  siteName = SITE_NAME;
  }
